import { DataManager, UrlAdaptor } from '@syncfusion/ej2-data';
import { DropDownList } from '@syncfusion/ej2-dropdowns';

import { routes } from '@/shared/routes';
import { ClientType } from '@/shared/types/enum';
import { ModelName } from '@/shared/types/model';

import { getControl } from '@/front/editable/state';
import { listen } from '@/front/event';

listen('editablesReady', () => {
  [...document.querySelectorAll('.editable[data-field="clientType"]')]
    .map((editable) => editable as HTMLDivElement)
    .forEach((editable) => {
      const form = editable.closest('form') as HTMLFormElement;

      const modelName = form.modelName.value as ModelName;

      if (modelName === 'Task' || modelName === 'RecurringTask') {
        const clientTypeDropDownList = getControl(editable.id) as DropDownList;

        const refresh = (clientType: ClientType) => {
          const selected = clientTypeDropDownList.value === clientType;

          // Task / Recurring Task
          [...form.querySelectorAll(`[data-client-type="${clientType}"]`)]
            .map((childContainer) => childContainer as HTMLElement)
            .forEach((childContainer) => {
              childContainer.classList.toggle('d-none', !selected);

              const childEditable = childContainer.querySelector('.editable') as HTMLDivElement;

              if (childEditable) {
                const childDropDownList = getControl(childEditable.id) as DropDownList;

                childDropDownList.enabled = selected;
              }
            });

          // Smart Task
          const smartTaskTypeInput = form.querySelector(`[name="smartTaskType"]`) as HTMLInputElement | null;

          if (smartTaskTypeInput) {
            const smartTaskTypeEditable = smartTaskTypeInput.closest('.editable') as HTMLDivElement;
            const smartTaskTypeDropDownList = getControl(smartTaskTypeEditable.id) as DropDownList;

            if (selected) {
              smartTaskTypeDropDownList.dataSource = new DataManager({
                url: routes.smartTasks.options.types({ clientType }),
                adaptor: new UrlAdaptor(),
              });
            }
          }

          const updateOnCompletionInput = form.querySelector(`[name="updateOnCompletion"]`) as HTMLInputElement | null;

          if (updateOnCompletionInput) {
            const updateOnCompletionEditable = updateOnCompletionInput.closest('.editable') as HTMLDivElement;
            const updateOnCompletionDropDownList = getControl(updateOnCompletionEditable.id) as DropDownList;

            if (selected) {
              updateOnCompletionDropDownList.dataSource = new DataManager({
                url: routes.smartTasks.options.updateFields({ clientType }),
                adaptor: new UrlAdaptor(),
              });
            }
          }
        };

        if (clientTypeDropDownList) {
          refresh(ClientType.Organisation);
          refresh(ClientType.Individual);

          clientTypeDropDownList.addEventListener('change', () => {
            refresh(ClientType.Organisation);
            refresh(ClientType.Individual);
          });
        }
      }
    });
});
